import React, { ReactText, useState } from 'react'
import './index.css'
import { Button, Popover } from 'antd'
import { EllipsisOutlined } from '@ant-design/icons'

export interface IMenu {
    label?: string
    disabled?: boolean
    onClick: () => void
    icon: React.ReactNode,

}

interface IProps{
    itemsMenu:IMenu[]
    buttonText?: React.ReactNode,
    type?:'ghost'|'default'|'primary'
    disabled?:boolean
}
const ButtonMenu: React.FC<IProps> = ({type='ghost', disabled,...props}) => {
    const [open, setOpen] = useState(false);

    const hide = () => {
        setOpen(false);
    };

    const handleOpenChange = (newOpen: boolean) => {
        setOpen(newOpen);
    };
    return (
        <Popover
            getPopupContainer={() => document.body}
            content={<div className='content-btn-menu'>
                {
                    props.itemsMenu.map((item) => <Button key={item.label} disabled={item.disabled} className='btn-item' onClick={()=>{
                        item.onClick()
                        hide()
                    }}>
                      {item.icon}  {item.label}
                    </Button>)
                }
            </div>}
            title=""
            trigger="click"
            open={open}
            onOpenChange={handleOpenChange}
        >
            {/* @ts-ignore */}
            <Button disabled={disabled} className='button-menu-core' type={type}>{Boolean(props.buttonText) ? props.buttonText :<EllipsisOutlined />}</Button>
        </Popover>
    )
}

export default ButtonMenu
